import { Stack } from '@mui/material';

import { LogoIcon } from './Icon';
import { GlassVariant, LogoColors } from './types';
import { LogoWordMark } from './WordMark';

interface Props {
    variant?: GlassVariant;
    width?: number;
    textColor?: LogoColors;
    glassColor?: LogoColors;
}

export const Logo = (props: Props) => {
    const {
        variant = 'fill',
        textColor = 'white',
        glassColor = 'gray',
        width = 250,
    } = props;

    const iconHeight = (185 / 290) * width;
    const wordHeight = (40 / 290) * width;

    return (
        <Stack alignItems="center" gap={wordHeight / 16}>
            <LogoIcon
                background="transparent"
                variant={variant}
                color={glassColor}
                size={iconHeight}
            />
            <LogoWordMark color={textColor} height={wordHeight} />
        </Stack>
    );
};

interface HorizontalProps {
    height?: number;
    variant?: GlassVariant;
    textColor?: LogoColors;
    glassColor?: LogoColors;
}

export function LogoHorizontal({
    height = 60,
    variant = 'fill',
    textColor = 'white',
    glassColor = 'gray',
}: HorizontalProps) {
    return (
        <Stack alignItems="center" gap={height / 32} direction="row">
            <LogoIcon size={height} variant={variant} color={glassColor} />
            <LogoWordMark color={textColor} height={height / 2} />
        </Stack>
    );
}
